import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/system";
import { BaseTextMergeEditor } from "../BaseTextMergeEditor";
import { TextField } from "@mui/material";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import TitleIcon from "@mui/icons-material/Title";
import { TextElement } from "../../../rule-engine-core/TextMerge/Elements/Text/TextElement";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";
import { BaseTextMergeElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import type { AppGlueAny } from "../../../rule-engine-core/Common/AppGlueAny";

export class TextElementEditor extends BaseTextMergeEditor<TextElement> {
    renderDisplay(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        return (
            <span
                style={
                    editContext.selectedElement?.id === this.getEditorData().id
                        ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                        : {}
                }
                onClick={() => {
                    editContext.setSelectedElement(config);
                }}
            >
                {this.editorData?.text}
                &nbsp;
            </span>
        );
    }

    renderEditor(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        return (
            <TextEditorImpl
                key={this.editorData?.id}
                config={config as TextElement}
                editContext={editContext}
            />
        );
    }

    getIcon(): JSX.Element {
        return <TitleIcon />;
    }
}

function TextEditorImpl(props: { config: TextElement; editContext: TextMergeEditContext }) {
    let [v, setV] = useState<string | undefined>();

    const inputRef = useRef<AppGlueAny>();
    const [_selectionStart, setSelectionStart] = React.useState();
    const updateSelectionStart = () => {
        if (inputRef && inputRef.current) {
            setSelectionStart(inputRef.current.selectionEnd);
            props.editContext.cursorPosition = inputRef.current.selectionEnd;
        }
    };

    useEffect(() => {
        setV(props.config!.text);
    });
    return (
        <Box
            padding={"3px"}
            margin={"3px"}
            bgcolor={"white"}
            overflow={"clip"}
            border={
                props.editContext.selectedElement?.id === props.config.id
                    ? "2px solid " + UIStyleConstants.RED_COLOR
                    : "1px solid " + UIStyleConstants.BLUE_COLOR
            }
            onClick={() => {
                props.editContext.setSelectedElement(props.config);
            }}
        >
            {props.editContext.selectedElement?.id === props.config.id ? (
                <>
                    <TextField
                        multiline={true}
                        fullWidth={true}
                        size={"small"}
                        value={v}
                        inputRef={inputRef}
                        onSelect={updateSelectionStart}
                        onChange={(e) => {
                            setV(e.target.value);
                            props.config!.text = e.target.value;
                        }}
                    ></TextField>
                </>
            ) : v ? (
                <span>{v}</span>
            ) : (
                "[Add Text Here]"
            )}
        </Box>
    );
}
